import { type Sequence, SequenceStatus, SequenceStepStatus, SequenceStopReason } from '@/models/sequence'

export const SEQUENCES_PATH = '/insure/internal/sequences'

export const sequencePath = (id: string) => `${SEQUENCES_PATH}/${id}`

export const leadSequencesPath = (leadId: string) => `/insure/internal/sales-leads/${leadId}#sequences`

export const STATUS_VARIANT: Record<SequenceStatus, 'default' | 'secondary' | 'outline'> = {
  [SequenceStatus.DRAFT]: 'outline',
  [SequenceStatus.RUNNING]: 'default',
  [SequenceStatus.PAUSED]: 'secondary',
  [SequenceStatus.STOPPED]: 'secondary',
  [SequenceStatus.COMPLETED]: 'secondary',
}

export const STOP_REASON_LABEL: Record<SequenceStopReason, string> = {
  [SequenceStopReason.COMPLETED]: 'Every step ran',
  [SequenceStopReason.MANUAL]: 'Stopped by a rep',
  [SequenceStopReason.TERMINAL_STATUS]: 'Lead was closed or unqualified',
  [SequenceStopReason.LEAD_REPLIED]: 'Lead replied',
}

export function progress(sequence: Sequence): string {
  const done = sequence.steps.filter((s) => s.status === SequenceStepStatus.COMPLETED).length
  return `${done} / ${sequence.steps.length}`
}
